import Vue from "vue";
// import VModal from "vue-js-modal";
import VModal from 'vue-js-modal/dist/ssr.nocss'
import 'vue-js-modal/dist/styles.css'

import "@/libs/Modal/index.scss";
Vue.use(VModal);
